import React, {useMemo, useEffect, useState, useRef} from 'react';
import ModalImage from "../components/ModalImage";
import {getCommentFileDetail} from "../services/inspection/CommentFile"
import {errorStatusHandle} from "../utils";

const ReadonlyComment = (props) => {
  const {
    remarkText = null,
    commentFiles=null
  } = props;

  const [isOpenModalImage, setIsOpenModalImage] = useState(false);
  const [imageModalInfo, setImageModalInfo] = useState(false);
  const containerRef = useRef(null);

  const processHTMLWithClasses = (htmlString, files) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    if (files) {
      files.forEach((file) => {
        if (file?.image_thumbnail) {

          const imgTags = doc.querySelectorAll(`img[data-id="${file.file_name}"]`);
          imgTags.forEach((img) => {
            img.classList.add('custom-image', 'clickable-image', 'cursor-pointer');
            img.setAttribute('src', file.image_thumbnail);
          })
        }
      });
    }

    doc.querySelectorAll('a').forEach(link => {
      link.classList.add('clickable-link', 'cursor-pointer');
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
    return doc.body.innerHTML;
  };

  const htmlContent = useMemo(() => {
    if (!remarkText) return '';
    return processHTMLWithClasses(remarkText, commentFiles)
  }, [remarkText]);

  const handleDownloadFile = async (id) => {
    try {
      const response = await getCommentFileDetail(id);
      if (response.data?.file_url) {
        const link = document.createElement("a");
        link.href = response.data.file_url;
        link.download = response.data.file_name || "download";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("ファイルが見つかりません")
      }
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const handleModalImage = (files, dataId) => {
    if (!files || !dataId) {
      return;
    }
    const found = files.find(item => item.file_name === dataId);
    if (found) {
      setIsOpenModalImage(true);
      setImageModalInfo({url: found.file_path, file_name: found.file_name})
    }
  };

  useEffect(() => {
    if (!remarkText) return;
    const handleClick = (event) => {
      const target = event.target;
      if (target.tagName === 'IMG' && target.classList.contains('clickable-image')) {
        const dataId = target.getAttribute('data-id');
        handleModalImage(commentFiles, dataId);
      }
      if (target.tagName === 'A' && target.classList.contains('clickable-link')) {
        event.preventDefault();
        handleDownloadFile(target.dataset.id);
      }
    };
    const container = containerRef.current;
    container.addEventListener('click', handleClick);
    return () => {
      container.removeEventListener('click', handleClick)
    }
  }, [remarkText, commentFiles]);

  return (
    <div
      className={`2xl:px-[14px] tenken__text-gray-900 2xl:py-[12px] xl:px-[12px] xl:py-[10px] px-[10px] w-full py-[8px] break-words whitespace-pre-wrap 2xl:max-w-[1587px] xl:max-w-[1219px] max-w-[1116px]  ${remarkText ? 'min-h-[120px]' : ''}`}>
      <div className={`${remarkText ? 'tiptap ProseMirror' : ''}`} ref={containerRef} dangerouslySetInnerHTML={{__html: htmlContent}}/>
      <ModalImage openModal={isOpenModalImage} setOpenModal={setIsOpenModalImage} imageInfo={imageModalInfo}/>
    </div>
  )
};

export default ReadonlyComment;